import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { upsertRoleMappingMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useUpsertRoleMapping = (refetch) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [upsertRoleMappingAction, { loading }] = useMutation(upsertRoleMappingMutation);

    const upsertRoleMapping = async ({ clientId, mappedName, roleId }) => {
        try {
            await upsertRoleMappingAction({
                onCompleted: () => {
                    refetch?.();

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: t("roleMapping.entity") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    clientId,
                    mappedName,
                    roleId,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        loading,
        upsertRoleMapping,
    };
};

export default useUpsertRoleMapping;
